<template>
<a @click.stop="" v-if="openTab" target="_blank" rel="noopener noreferrer" :href="href">
  <slot></slot>
</a>
<a v-else :href="href">
  <slot></slot>
</a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      default: ''
    },
    openTab: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/link.vue